export const getTextLengthValidation = ({ isRequired }: { isRequired: boolean }) => ({
	MIN: isRequired ? 1 : 0,
	MAX: 255,
});

export const splitValuesOnSpace = (values: string[]) =>
	values.flatMap((val) => val.split(/[\s]/g).filter((fragment) => fragment !== '') ?? []);
